@let cartMinorUnit = totals().currency_minor_unit || 2;
@let formValues = checkoutForm.value;

<div class="container">
  <div class="header">
    <app-back-button>Back to store</app-back-button>
  </div>

  <form [formGroup]="checkoutForm" class="content">
    <div class="content__general">
      @if (!isAuthenticated()) {
        <button
          type="button"
          class="guest-sign-in-banner"
          (click)="onSignInClick()"
        >
          <span class="guest-sign-in-banner__icon">
            <i class="icon icon-user-outline"></i>
          </span>
          <span class="guest-sign-in-banner__text">
            Sign in to earn rewards points on this order
          </span>
        </button>
      }

      @if (isUberDeliveryOutOfRange()) {
        <div class="content__general-warning">
          <p class="content__general-warning-title">
            We couldn't place your order
          </p>
          <p class="content__general-warning-text">
            {{ UBER_OUT_OF_RANGE_MESSAGE }}
          </p>
        </div>
      }


      <h2 class="content__general-title">Order Details</h2>

      <section class="content__general_shipping-details shipping-details">
        <div class="shipping-details__get-way">
          <app-option-switcher
            formControlName="shippingMethod"
            [options]="SHIPPING_OPTIONS()"
          />
        </div>

        @if ((formValues['shippingMethod'] == ShippingMethod.Delivery &&
          checkoutForm.value['deliveryAddress']) ||
        (formValues['shippingMethod'] == ShippingMethod.Pickup &&
          checkoutForm.value['pickupAddress'])) {
          <div class="shipping-details__method">
            <div class="pickup-time__title">
              <i class="icon icon-clock-outline"></i>
              <p>Pickup Time</p>
            </div>
            <app-option-switcher
              formControlName="shippingMethodDetails"
              [disabled]="isShippingDateTimesLoading()"
              [options]="
                formValues['shippingMethod'] == ShippingMethod.Delivery
                  ? DELIVERY_TIME_OPTIONS()
                  : PICKUP_TIME_OPTIONS()
              "
            />
          </div>
        }
      </section>

      <section class="content__general_details pickup-address">
        <h3 class="pickup-address__title title">
          @if (formValues['shippingMethod'] == ShippingMethod.Delivery) {
            Delivery Address
          }

          @if (formValues['shippingMethod'] == ShippingMethod.Pickup) {
            Pickup Location
          }
        </h3>

        <ul class="pickup-address__list">
          @if (formValues['shippingMethod'] == ShippingMethod.Delivery) {
            <li class="delivery-address__list_item detail">
              <app-clickable-row
                icon="icon-pin-outline"
                placeholder="Select Address"
                [label]="formValues['deliveryAddress'] | address"
                (buttonClick)="onDeliveryAddressClick()"
              />
            </li>

            <li class="delivery-address__list_item detail">
              @let dropoff = formValues['dropoff'];
              @let dropoffLabel =
                (dropoff?.apt_suite ? dropoff.apt_suite + ' | ' : '') +
                (dropoff?.delivery?.label ? dropoff.delivery?.label + ' | ' : '') +
                (dropoff?.instructions ? dropoff.instructions : '');

              <app-clickable-row
                icon="icon-box-outline"
                placeholder="Drop Off Options"
                [label]="dropoffLabel"
                (buttonClick)="onDropoffClick()"
              />
            </li>
          }

          @if (formValues['shippingMethod'] == ShippingMethod.Delivery &&
          availableShippingMethods().length > 0 && !isLoadingShippingMethods() && formValues['deliveryAddress']) {
            <li class="delivery-address__list_item detail shipping-method">
              <app-card-selector
                formControlName="selectedShippingMethod"
                [options]="availableShippingCardOptions()"
              />
            </li>
          }

          @if (formValues['shippingMethod'] == ShippingMethod.Pickup) {
            <li class="pickup-address__list_item detail">
              @let pickupAddress = checkoutForm.get('pickupAddress')?.value;
              <app-clickable-row
                icon="icon-pin-outline"
                placeholder="Select Address, to get directions"
                arrowLabel="Get Pickup Directions"
                [label]="pickupAddress | address"
                [disabled]="
                  isUpdatingShippingRate() || isLoadingShippingMethods()
                "
                [loading]="
                  isUpdatingShippingRate() || isLoadingShippingMethods()
                "
                [arrowLabelDisabled]="
                  !pickupAddress?.label || isLoadingShippingMethods()
                "
                (buttonClick)="onPickupAddressClick()"
                (arrowButtonClick)="
                  openGoogleMapsLocation(pickupAddress.label)
                "
              />
            </li>
          }

          <li class="pickup-address__list_item detail map">
            <google-map
              height="222px"
              width="100%"
              mapId="SHIPPING_SELECTION_MAP"
              [options]="GOOGLE_MAP_OPTIONS"
              [zoom]="googleMapZoom"
              [center]="googleMapCenter"
              (mapInitialized)="onMapInitialized($event)"
            >
              @for (marker of googleMapMarkers; track $index) {
                <map-advanced-marker [position]="marker" />
              }
            </google-map>
          </li>
        </ul>
      </section>

      <section class="content__general_contact-details contact-details">
        <h3 class="contact-details__title title">Contact Details</h3>

        <ul class="contact-details__list">
          <li class="contact-details__list_item contact-details__list_item--full-name">
            <div class="contact-details__list_item-field">
              <app-editable-row
                icon="icon-user-outline"
                placeholder="First Name"
                autocomplete="given-name"
                formControlName="first_name"
              />
            </div>

            <div class="contact-details__list_item-field">
              <app-editable-row
                placeholder="Last Name"
                autocomplete="family-name"
                formControlName="last_name"
              />
            </div>
          </li>
          <li class="contact-details__list_item">
            <app-editable-row
              icon="icon-phone-outline"
              placeholder="(800) 000-0000"
              type="tel"
              autocomplete="tel"
              mask="+0 (000) 000-0000||0 (000) 000-0000||(000) 000-0000"
              [display]="formValues['phone'] | phone"
              [normalizeValue]="normalizeUSPhoneNumber"
              formControlName="phone"
            />
          </li>
          <li class="contact-details__list_item">
            <app-editable-row
              placeholder="Email"
              icon="icon-mail-outline"
              type="email"
              autocomplete="email"
              formControlName="email"
            />
          </li>
        </ul>
      </section>

      @if (formValues['shippingMethod'] == ShippingMethod.Delivery) {
        <section class="content__general_order-notes order-notes">
          <h3 class="order-notes__title title">Order Notes</h3>

          <ul class="order-notes__list">
            <li class="order-notes__list_item">
              <app-clickable-row
                icon="icon-file-outline"
                placeholder="Notes"
                [label]="formValues['note']"
                (buttonClick)="onNoteClick()"
              />
            </li>
          </ul>
        </section>
      }

      @if (+(totals()?.total_price || '0') > 0) {
        <section class="content__general_payments payments">
          <h3 class="payments__title title">Payment Details</h3>

          @if (isApplePayAvailable()) {
            <div class="payments__apple-pay">
              @if (usingApplePay()) {
                <div class="payments__apple-pay-selected">
                  <span class="payments__apple-pay-label">Apple Pay selected</span>
                  <button
                    type="button"
                    class="payments__apple-pay-change"
                    (click)="clearApplePay()"
                  >
                    Change
                  </button>
                </div>
              } @else {
                <app-apple-pay-button
                  [amount]="applePayAmount()"
                  [label]="'Happy Ordering'"
                  [currencyCode]="totals().currency_code || 'USD'"
                  [countryCode]="'US'"
                  [disabled]="isCheckoutLocked() || isSubmitLoading()"
                  (tokenReceived)="onApplePayTokenReceived($event)"
                  (paymentError)="onApplePayError($event)"
                />
              }
            </div>

            @if (!usingApplePay()) {
              <div class="payments__divider">
                <span class="payments__divider-line"></span>
                <span class="payments__divider-text">or pay with card</span>
                <span class="payments__divider-line"></span>
              </div>
            }
          }

          @if (!usingApplePay() && isAuthenticated() && savedCards().length > 0) {
            <div class="payments__saved-cards">
              <p class="payments__saved-cards-label">Your saved cards</p>
              <div class="payments__saved-cards-list" role="radiogroup">
                @for (card of savedCards(); track card.id) {
                  <div
                    class="payments__saved-card"
                    [class.payments__saved-card--selected]="selectedSavedCard()?.id === card.id"
                    (click)="onSavedCardSelect(card)"
                    role="radio"
                    [attr.aria-checked]="selectedSavedCard()?.id === card.id"
                    tabindex="0"
                    (keydown.enter)="onSavedCardSelect(card)"
                  >
                    <span class="payments__saved-card-radio">
                      <span class="payments__saved-card-radio-dot"></span>
                    </span>
                    <span class="payments__saved-card-info">
                      <span class="payments__saved-card-brand">
                        {{ getCardBrandName(card.card_type) }} *{{ card.last4 }}
                      </span>
                      <span class="payments__saved-card-expiry">
                        Expires {{ card.exp_month }}/{{ card.exp_year }}
                      </span>
                    </span>
                    @if (card.is_default) {
                      <span class="payments__saved-card-badge">Default</span>
                    }
                  </div>
                }

                <div
                  class="payments__saved-card payments__saved-card--new"
                  [class.payments__saved-card--selected]="!usingSavedCard()"
                  (click)="useNewCard()"
                  role="radio"
                  [attr.aria-checked]="!usingSavedCard()"
                  tabindex="0"
                  (keydown.enter)="useNewCard()"
                >
                  <span class="payments__saved-card-radio">
                    <span class="payments__saved-card-radio-dot"></span>
                  </span>
                  <span class="payments__saved-card-info">
                    <span class="payments__saved-card-brand">Use a different card</span>
                  </span>
                </div>
              </div>
            </div>
          }

          @if (!usingApplePay() && !usingSavedCard()) {
            <ul class="payments__list">
              @let payment_method = formValues['paymentMethod'];

              @for (paymentMethod of paymentMethods(); track $index) {
                <li class="payments__list_item">
                  <app-clickable-row
                    [icon]="$any(paymentMethod)['icon']"
                    [placeholder]="paymentMethod.title"
                    [label]="
                      payment_method === paymentMethod.id ? paymentMethod.title : ''
                    "
                    (buttonClick)="onPaymentMethodClick(paymentMethod)"
                  />
                  @if (expandedPaymentMethodId() === paymentMethod.id &&
                  ((paymentMethod.fields || []).length > 0 || paymentMethod.id.includes('clover') || paymentMethod.gateway === 'stripe')) {
                    <fieldset class="payments__list_item_fields" [@slideInOut]>
                      @if (paymentMethod.id.includes('clover')) {
                        <app-clover-payment #cloverPayment></app-clover-payment>
                      } @else if (paymentMethod.gateway === 'stripe') {
                        <app-stripe-card-element
                          #stripeCardElement
                          [publishableKey]="paymentMethod.publishable_key || stripePublishableKey"
                        />
                      } @else {
                        <div [formGroupName]="'paymentFields'">
                          <app-payment-fields [fields]="paymentMethod.fields" />
                        </div>
                      }
                    </fieldset>
                  }
                </li>
              }
            </ul>
          }
        </section>

        @if (isCardPayment() || usingSavedCard()) {
          <section class="content__general_billing-details billing-details">
            <h3 class="billing-details__title title">Billing Address</h3>

            <ul class="billing-details__list">
              <div class="billing-details__checkbox">
                <app-checkbox
                  label="Same as Contact Details"
                  formControlName="useSameAsContactDetails"
                />
              </div>

              @if (!formValues['useSameAsContactDetails']) {
                <li class="billing-details__list_item billing-details__list_item--full-name">
                  <div class="billing-details__list_item-field">
                    <app-editable-row
                      icon="icon-user-outline"
                      placeholder="First Name"
                      autocomplete="billing given-name"
                      formControlName="billing_first_name"
                    />
                  </div>

                  <div class="billing-details__list_item-field">
                    <app-editable-row
                      placeholder="Last Name"
                      autocomplete="billing family-name"
                      formControlName="billing_last_name"
                    />
                  </div>
                </li>
              }

              <li class="billing-details__list_item">
                <app-clickable-row
                  icon="icon-pin-outline"
                  placeholder="Select Billing Address"
                  [label]="billingAddressDisplay() | address"
                  (buttonClick)="onBillingAddressClick()"
                />
              </li>
            </ul>
          </section>
        }
      }
    </div>

    <div class="content__prices">
      <h4 class="content__prices_title">Your Cart Order</h4>

      <section class="content__prices_cart">
        <app-checkout-details-cart [isLocked]="isCheckoutLocked()" />
      </section>

      <section class="content__prices_coupon">
        <app-checkout-details-coupon [isLocked]="isCheckoutLocked()" />
      </section>

      <section class="content__prices_price-totals price-totals">
        <ul class="price-totals__list">
          <li class="price-totals__list_item price-total">
            @let totalItems = totals().total_items || 0;
            <span class="price-total__label">Subtotal</span>
            <span class="price-total__value">
              {{ totalItems | formattedCurrency: cartMinorUnit }}
            </span>
          </li>

          @if (formValues['shippingMethod'] == ShippingMethod.Delivery &&
          +(totals()?.total_shipping || '0') > 0) {
            <li class="price-totals__list_item price-total">
              <span class="price-total__label">
                Delivery Fee ({{ selectedShippingMethod()?.name }})
              </span>
              <span class="price-total__value">
                {{ totals()?.total_shipping | formattedCurrency:cartMinorUnit }}
              </span>
            </li>
          }

          <li class="price-totals__list_item price-total">
            @let totalTax = +(totals().total_tax || '0') || 0;
            <!--            @let totalFees = +(totals()?.total_fees || '0') || 0;-->
            <span class="price-total__label">Fees & Estimated Tax</span>
            <span class="price-total__value">
              {{ totalTax | formattedCurrency: cartMinorUnit }}
            </span>
          </li>

          @for (fee of fees(); track fee.key) {
            <li class="price-totals__list_item price-total">
              <span class="price-total__label">{{ fee.name }}</span>
              <div class="price-total__value">
                {{ fee.totals.total | formattedCurrency: fee.totals.currency_minor_unit }}

                @if (fee.key.includes('tip-amount-')) {
                  <button
                    type="button"
                    class="price-total__value-remove"
                    [disabled]="isApplyingTip() || isCheckoutLocked()"
                    (click)="handleRemoveTip()"
                  >
                    <i class="price-total__value-trash icon icon-trash"></i>
                  </button>
                }
              </div>
            </li>
          }

          @for (coupon of coupons(); track coupon.code) {
            <li class="price-totals__list_item price-total">
              <span class="price-total__label">Promo Code ({{ coupon.code }})</span>


              <div class="price-total__value">
                {{ coupon.totals.total_discount | formattedCurrency: coupon.totals.currency_minor_unit }}

                <button
                  type="button"
                  class="price-total__value-remove"
                  [disabled]="isCheckoutLocked()"
                  (click)="handleRemoveCoupon(coupon)"
                >
                  <i class="price-total__value-trash icon icon-trash"></i>
                </button>
              </div>
            </li>
          }

          <li class="price-totals__list_item price-total">
            <span class="price-total__label">Grand Total</span>
            <span class="price-total__value">
              {{ +totals().total_price | formattedCurrency: cartMinorUnit }}
            </span>
          </li>
        </ul>

        <div class="secure-payment">
          <div class="secure-payment__label">
            <i class="icon icon-shield-check-outline"></i>
            <span>Secure Payment</span>
          </div>
          <div class="secure-payment__cards">
            <span class="icon-visa"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>
            <span class="icon-mastercard"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
            <span class="icon-amex"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span></span>
            <span class="icon-discover"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
          </div>
        </div>

        @if (formValues['shippingMethod'] == ShippingMethod.Delivery) {
          <div class="delivery-notice">
            <p class="delivery-notice__title">Delivery Notice:</p>
            <p class="delivery-notice__text">
              Your order will be delivered by our partnership with Uber. Your order will be sent out for delivery as
              soon as it is ready and you will be provided with a tracking link from Uber. Enjoy!
            </p>
          </div>
        }
      </section>

      <section class="content__prices_tips tips">
        <div class="tips__control">
          <app-tip-selector [(isApplyingTip)]="isApplyingTip" />
        </div>

        <span class="tips__note">
          The recommended tip is based on the delivery distance and effort. 100%
          of the tip goes to your driver
        </span>
      </section>

      <div
        class="content__prices_order order"
        [tooltip]="hasPlaceOrderError() ? getOrderBlockedMessage() : undefined"
      >
        <app-button
          class="order__button"
          [size]="ButtonSize.Large"
          [disabled]="
            isCheckoutLocked() ||
            hasPlaceOrderError() ||
            isShippingDateTimesLoading() ||
            isUpdatingShippingRate() ||
            isApplyingTip() ||
            isLoadingShippingMethods() ||
            isSubmitLoading() ||
            isCartLoading()
          "
          [loading]="isSubmitLoading()"
          (buttonClick)="onPlaceOrderClick()"
        >
          <div class="order__button_content">
            <span class="order__button_name">Place Order</span>
            <span class="order__button_price">
            {{ +totals().total_price | formattedCurrency: cartMinorUnit }}
          </span>
          </div>
        </app-button>
      </div>
    </div>
  </form>
</div>
